import React from "react";
import { connect } from "react-redux";
import Container from "../components/Container";
import SkyLight from "react-skylight";

if (process.env.BROWSER) {
    require("flexboxgrid");
}

const Slider = React.createClass({
    propTypes: {
        title: React.PropTypes.string.isRequired,
        foci: React.PropTypes.array,
        focus_columns: React.PropTypes.number.isRequired,
    },
    getInitialState: function () {
        return {
            openItem: this.props.foci.length == 1 ? 0 : false,
        };
    },
    componentDidMount: function () {
        this._renderSwiper();
    },
    componentDidUpdate: function () {
        this._renderSwiper();
    },
    _renderSwiper: function () {
        if (this.props.foci.length > 1) {
            window.mySwiper = new Swiper(this.refs.slider, {
                direction: "horizontal",
                spaceBetween: 15,
                slidesPerView: this.props.focus_columns,
                slidesPerGroup: this.props.focus_columns,
                loop: true,
                nextButton: this.refs.next,
                prevButton: this.refs.prev,
                pagination: this.refs.pagination,
                paginationType: "custom",
                paginationClickable: true,
                paginationCustomRender: function (swiper, current, total) {
                    var pagers = "";
                    for (var items = 1; items <= total; items++) {
                        if (items == current) {
                            for (
                                let i = 0;
                                i < swiper.params.slidesPerGroup;
                                i++
                            ) {
                                pagers +=
                                    '<span onClick="window.mySwiper.slideTo(' +
                                    items * swiper.params.slidesPerGroup +
                                    ')" class="pagination-bullet active"></span>';
                            }
                        } else {
                            for (
                                let i = 0;
                                i < swiper.params.slidesPerGroup;
                                i++
                            ) {
                                pagers +=
                                    '<span onClick="window.mySwiper.slideTo(' +
                                    items * swiper.params.slidesPerGroup +
                                    ')" class="pagination-bullet"></span>';
                            }
                        }
                    }
                    return pagers;
                },
                breakpoints: {
                    500: {
                        slidesPerView: 1,
                        slidesPerGroup: 1,
                        spaceBetweenSlides: 15,
                        pagination: null,
                    },
                    650: {
                        slidesPerView: 1,
                        slidesPerGroup: 1,
                        spaceBetweenSlides: 15,
                    },
                    840: {
                        slidesPerView:
                            this.props.focus_columns < 2
                                ? this.props.focus_columns
                                : 2,
                        slidesPerGroup:
                            this.props.focus_columns < 2
                                ? this.props.focus_columns
                                : 2,
                        spaceBetweenSlides: 15,
                    },
                    1120: {
                        slidesPerView:
                            this.props.focus_columns < 3
                                ? this.props.focus_columns
                                : 3,
                        slidesPerGroup:
                            this.props.focus_columns < 3
                                ? this.props.focus_columns
                                : 3,
                        spaceBetweenSlides: 15,
                    },
                },
            });
        }
    },
    _open: function (index) {
        this.setState({
            openItem: index,
        });
    },
    render: function () {
        const fociStyle = {
            padding:
                this.state.openItem !== false || this.props.foci.length == 1
                    ? 0
                    : "",
        };
        return (
            <section className="highlight">
                <Container>
                    <div className="foci" style={fociStyle}>
                        {this.props.title ? <h2>{this.props.title}</h2> : null}
                        <div className="swiper-slide focus active">
                            <h3>
                                {this.props.foci[this.state.openItem].title}
                            </h3>
                            <img
                                src={this.props.foci[this.state.openItem].image}
                                alt={this.props.foci[this.state.openItem].title}
                            />

                            <SkyLight
                                hideOnOverlayClicked={true}
                                ref="Krebsvorsorge"
                                title="Krebsvorsorge"
                            >
                                <ul>
                                    <li>PAP Abstrich </li>
                                    <li>Thin Prep/ Dünnschichtzytologie </li>
                                    <li>HPV Abstrich </li>
                                    <li>Vaginaler Ultraschall </li>
                                    <li>Immunologischer Stuhltest </li>
                                    <li>Chlamydien Schnelltest </li>
                                    <li>
                                        Urintest auf Blasenkrebs/ bladder check
                                    </li>
                                    <li>Blutuntersuchungen </li>
                                </ul>
                            </SkyLight>

                            <SkyLight
                                hideOnOverlayClicked={true}
                                ref="Schwangerschaftsbetreuung"
                                title="Schwangerschaftsbetreuung"
                            >
                                <ul>
                                    <li>Schwangerschaftstest </li>
                                    <li>
                                        vorgeburtliche Diagnostik von
                                        Chromosomenstörungen insbesondere
                                        Trisomie 21, 13 und 18 mittels
                                        nicht-invasivem Praenatal Test (NIPT),
                                        First-Trimester-Screening nach FMF
                                        Deutschland Nackenfaltenmessung/
                                        Nackenfaltentransparenz
                                    </li>
                                    <li>
                                        Fehlbildungsultraschall/ Organscreening{" "}
                                    </li>
                                    <li>
                                        Baby-Fernsehen (3D/ 4D – Ultraschall){" "}
                                    </li>
                                    <li>
                                        Schwangerschaftsvorsorgeuntersuchung{" "}
                                    </li>
                                    <li>
                                        Untersuchung auf Infektion in der
                                        Schwangerschaft z.B. Toxoplasmose, CMV,
                                        Ringelröteln
                                    </li>
                                    <li>
                                        Screening auf Streptokokken-Infektion{" "}
                                    </li>
                                    <li>Screening auf Gestationsdiabetes </li>
                                </ul>
                            </SkyLight>

                            <SkyLight
                                hideOnOverlayClicked={true}
                                ref="Kinderwunschberatung"
                                title="Kinderwunschberatung"
                            >
                                <ul>
                                    <li>Folsäure </li>
                                    <li>
                                        Impfschutzkontrolle gegen Röteln und
                                        Varizellen
                                    </li>
                                    <li>Ernährungsberatung </li>
                                    <li>Zyklusanalyse </li>
                                </ul>
                            </SkyLight>

                            <SkyLight
                                hideOnOverlayClicked={true}
                                ref="Sterilitätsdiagnostik"
                                title="Sterilitätsdiagnostik"
                            >
                                <ul>
                                    <li>Hormonanalysen </li>
                                    <li>
                                        Ambulante Bauchspiegelung/
                                        Gebärmutterspiegelung, Überprüfung der
                                        Eileiterdurchgängigkeit{" "}
                                    </li>
                                </ul>
                            </SkyLight>

                            <SkyLight
                                hideOnOverlayClicked={true}
                                ref="Empfängnisverhütung"
                                title="Beratung zur Empfängnisverhütung"
                            >
                                <ul>
                                    <li> Pille </li>
                                    <li> Minipille </li>
                                    <li> Pille danach </li>
                                    <li> Vaginalring/ Nuvaring </li>
                                    <li> Dreimonatsspritze </li>
                                    <li>
                                        {" "}
                                        Hormonspirale/ Mirena/ Jaydess/ Kyleena{" "}
                                    </li>
                                    <li> Kupferspirale </li>
                                    <li> IUB Kupferperlen-Ball </li>
                                    <li> Sterilisation </li>
                                </ul>
                            </SkyLight>

                            <SkyLight
                                hideOnOverlayClicked={true}
                                ref="Teenager"
                                title="Teenager-Sprechstunde"
                            >
                                <ul>
                                    <li>Verhütung </li>
                                    <li>körperliche Entwicklung </li>
                                    <li>Regelbeschwerden </li>
                                    <li>Intimhygiene </li>
                                    <li>
                                        HPV-Impfung gegen Gebärmutterhalskrebs
                                        und genitale Warzen{" "}
                                    </li>
                                </ul>
                            </SkyLight>

                            <SkyLight
                                hideOnOverlayClicked={true}
                                ref="Brustultraschall"
                                title="Brustultraschall"
                            >
                                <ul>
                                    <li>
                                        {" "}
                                        Früherkennung von Brustkrebs (ab 30
                                        Jahren 1x jährlich){" "}
                                    </li>
                                    <li>
                                        Abklärung von Brustbeschwerden,
                                        Brustknoten, Brusttumoren, Zysten,
                                        dichtes Brustdrüsengewebe{" "}
                                    </li>
                                    <li>
                                        Gewebeprobe (HS-Stanze) in örtlicher
                                        Betäubung{" "}
                                    </li>
                                </ul>
                            </SkyLight>

                            <SkyLight
                                hideOnOverlayClicked={true}
                                ref="Wechseljahrsbeschwerden"
                                title="Beratung bei Wechseljahrsbeschwerden"
                            >
                                <ul>
                                    <li>Pflanzliche Präparate</li>
                                    <li>Hormonersatztherapie </li>
                                    <li>Ernährungsberatung </li>
                                </ul>
                            </SkyLight>

                            <div className="row">
                                <div className="col-xs-12 col-sm-12 col-md-6">
                                    <h3>Leistungsspektrum:</h3>
                                    <p>
                                        <a
                                            href="javascript: void(0);"
                                            onClick={() =>
                                                this.refs.Krebsvorsorge.show()
                                            }
                                        >
                                            Krebsvorsorge
                                        </a>
                                        <br />
                                        <a
                                            href="javascript: void(0);"
                                            onClick={() =>
                                                this.refs.Schwangerschaftsbetreuung.show()
                                            }
                                        >
                                            Schwangerschaftsbetreuung
                                        </a>
                                        <br />
                                        <a
                                            href="javascript: void(0);"
                                            onClick={() =>
                                                this.refs.Kinderwunschberatung.show()
                                            }
                                        >
                                            Kinderwunschberatung
                                        </a>
                                        <br />

                                        <a
                                            href="javascript: void(0);"
                                            onClick={() =>
                                                this.refs.Empfängnisverhütung.show()
                                            }
                                        >
                                            Beratung zur Empfängnisverhütung
                                        </a>
                                        <br />

                                        <a
                                            href="javascript: void(0);"
                                            onClick={() =>
                                                this.refs.Teenager.show()
                                            }
                                        >
                                            Teenager-Sprechstunde
                                        </a>
                                        <br />

                                        <a
                                            href="javascript: void(0);"
                                            onClick={() =>
                                                this.refs.Brustultraschall.show()
                                            }
                                        >
                                            Brustultraschall
                                        </a>
                                        <br />
                                        <a
                                            href="javascript: void(0);"
                                            onClick={() =>
                                                this.refs.Wechseljahrsbeschwerden.show()
                                            }
                                        >
                                            Wechseljahrsbeschwerden
                                        </a>
                                        <br />
                                    </p>
                                </div>
                                <div className="col-xs-12 col-md-6">
                                    <h3>Besonderheiten:</h3>
                                    <p>
                                        First Trimester Screening mit
                                        Nackenfaltenmessung
                                        <br />
                                        3D/4D-Ultraschall und
                                        Farbdopplersonographie
                                        <br />
                                        Brust-Diagnostik <br />
                                        Psychosomatische Grundversorgung
                                    </p>
                                </div>
                            </div>
                            <div style={{ clear: "both" }} />
                            {this.props.foci.length != 1 ? (
                                <div className="focus-morelink">
                                    <a
                                        href="javascript: void(0);"
                                        onClick={this._open.bind(this, false)}
                                    >
                                        zurück
                                    </a>
                                </div>
                            ) : null}
                        </div>
                    </div>
                </Container>
            </section>
        );
    },
});

const mapStateToProps = (state) => {
    return {
        title: state.focus_title,
        foci: state.foci,
        focus_columns: state.focus_columns,
    };
};

export default connect(mapStateToProps)(Slider);



// WEBPACK FOOTER //
// ./src/js/containers/Slider.js